<template>
  <div class="item-wish">
    <a v-if="!wishActive" class="btn-wish" @click.prevent="toggleFavorite">
      <i class="icon-heart" />
    </a>
    <a v-else class="btn-wish" @click.prevent="toggleFavorite">
      <i class="icon-heart icon-heart-active" />
    </a>
  </div>
</template>

<script setup>
import fireWishlistEvent from '@global/gtm/wishlist';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

const { postFavoriteAPI, deleteFavoriteAPI } = useAxiosAPI();

const props = defineProps({
  wishActive: {
    type: Boolean,
    required: true,
  },
  custommarketId: {
    type: String,
    required: true,
  },
  productName: {
    type: String,
    required: true,
  },
  productSellPrice: {
    type: Number,
    required: true,
  },
  selectedColor: {
    type: String,
  },
  selectedSpec: {
    type: String,
    default: '',
  },
});

function toggleFavorite(event) {
  const isFavorite = event.target.classList.contains('icon-heart-active');
  const nowUrl = window.location.href;

  if (!isFavorite) {
    postFavoriteAPI(
      {
        CustomMarketID: props.custommarketId,
      },
      {
        handle401: nowUrl,
      },
    )
      .then((res) => {
        if (res.data.Code === 200) {
          if (res.data.Response) {
            event.target.classList.add('icon-heart-active');
            fireWishlistEvent({
              id: props.custommarketId,
              name: props.productName,
              sellPrice: props.productSellPrice,
              color: props.selectedColor,
              size: props.selectedSpec,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } else {
    deleteFavoriteAPI(
      {
        data: { CustomMarketID: props.custommarketId },
      },
      {
        handle401: nowUrl,
      },
    )
      .then((res) => {
        if (res.data.Code === 200) {
          if (res.data.Response) {
            event.target.classList.remove('icon-heart-active');
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
</script>
